import React, { useMemo } from "react";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

interface InviteOrganizationsFormProps {
  emailInputs: string[];
  invitationsLoading: boolean;
  onAddEmailInput: () => void;
  onUpdateEmailInput: (index: number, value: string) => void;
  onSendInvitations: () => void;
  onSearchOrganization: () => void;
}

export const InviteOrganizationsForm: React.FC<
  InviteOrganizationsFormProps
> = ({
  emailInputs,
  invitationsLoading,
  onAddEmailInput,
  onUpdateEmailInput,
  onSendInvitations,
  onSearchOrganization,
}) => {
  const hasValidEmails = useMemo(() => {
    return emailInputs.some((email) => email.trim() !== "");
  }, [emailInputs]);

  return (
    <div className="tab-row invitations">
      <div className="tab-row-texts">
        <label>Invite organisations</label>
        Build strong partnerships by inviting other organisations' members
      </div>
      <div className="sendInvitations">
        <div className="invite-inputs">
          {emailInputs.map((email, index) => (
            <div key={index} className="invite-input-row">
              <span className="p-input-icon-left">
                <i className="pi pi-envelope" />
                <InputText
                  value={email}
                  placeholder="Enter email address"
                  onChange={(e) => onUpdateEmailInput(index, e.target.value)}
                />
              </span>
            </div>
          ))}
        </div>
        <div className="invitations-actions">
          <div className="invitations-actions-addNew" onClick={onAddEmailInput}>
            <i className="pi pi-plus"></i>Add another
          </div>
          <div className="invitations-action-buttons">
            <Button
              label="Search for an organisation"
              className="search-org-button"
              onClick={onSearchOrganization}
            />
            <Button
              label="Send invites"
              onClick={hasValidEmails ? onSendInvitations : undefined}
              disabled={!hasValidEmails || invitationsLoading}
              loading={invitationsLoading}
              className="send-invites-button"
            />
          </div>
        </div>
        <div className="invitations-info">
          <p>
            Invitations can be sent only to registered users. Ask your team
            members to sign up first if they don’t have an account.
          </p>
        </div>
      </div>
    </div>
  );
};
